import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PortfolioPage from './components/PortfolioPage';
import ServicesPage from './components/ServicesPage';
import FooterSection from './components/FooterSection';
import BackToTop from './components/BackToTop';
import Preloader from './components/Preloader';

const Home = () => (
  <>
    <section id="hero" className="pt-24"><HeroSection /></section>
    <section id="about"><AboutSection /></section>
  </>
);

const App = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && <Preloader />}
      {!loading && (
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/services" element={<ServicesPage />} />
            </Routes>
            <FooterSection />
            <BackToTop />
          </div>
        </Router>
      )}
    </>
  );
};

export default App;
